import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65b6ebce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/PC.scss?vue&type=style&index=0&id=65b6ebce&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=65b6ebce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b6ebce",
  null
  
)

export default component.exports